import { render, staticRenderFns } from "./PrimarySystem.vue?vue&type=template&id=a02ada4c&scoped=true"
import script from "./PrimarySystem.vue?vue&type=script&lang=js"
export * from "./PrimarySystem.vue?vue&type=script&lang=js"
import style0 from "./PrimarySystem.vue?vue&type=style&index=0&id=a02ada4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02ada4c",
  null
  
)

export default component.exports